import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import AreaStaticChip from '@ifeng-fe/container_content/common/client/components/areaStaticChip';

class Affix extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { chipObj, floatAd },
        } = this.props;

        const affix = (
            <Chip
                id={chipObj.floatAd}
                type="static"
                title="浮动广告"
                groupName="浮动"
                translate="handleAreaAd"
                content={floatAd}>
                <AreaStaticChip styleName={styles.float_box} />
            </Chip>
        );

        return ReactDOM.createPortal(affix, document.body);
    }
}

export default errorBoundary(Affix);
